import { render, staticRenderFns } from "./ProductInfoData.vue?vue&type=template&id=431ccfd0&scoped=true&"
import script from "./ProductInfoData.vue?vue&type=script&lang=js&"
export * from "./ProductInfoData.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoData.vue?vue&type=style&index=0&id=431ccfd0&prod&lang=scss&scoped=true&"
import style1 from "./ProductInfoData.vue?vue&type=style&index=1&id=431ccfd0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431ccfd0",
  null
  
)

export default component.exports